module.exports = __webpack_public_path__ + "img/ios.2e1f039e.svg";